import { useTheme } from "@material-ui/core/styles";
import type { SvgIconProps } from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";

/**
 * The arrow of a button that SENDS. It always goes in the button's `endIcon` and points the way the
 * line reads.
 *
 * In Hebrew a label runs right to left, so "forward" is left: the arrow sits at the label's END (its
 * left side) and points left, away from the words — "שליחה בכל זאת ◄". As a `startIcon` it lands on
 * the RIGHT, where a mirrored arrow points back into its own label and an unmirrored one points
 * backwards; that was the recurring mistake this replaces (Haim, 2026-10-21). A "back" button keeps
 * its arrow at the start, pointing outward, and an icon-only send button (a chat composer, a row's
 * IconButton) has no label to point into and keeps a plain mirrored icon.
 */
export default function ForwardSendIcon({ sx, ...props }: Omit<SvgIconProps, "sx"> & { sx?: Record<string, unknown> }) {
  const theme = useTheme();
  return <SendIcon {...props} sx={{ ...(theme.direction === "rtl" ? { transform: "scaleX(-1)" } : {}), ...sx }} />;
}
